const forbiddenInstances = ['caidas','checkout','consulta','fusionado','noshows','postventa','waitlist'];
export default forbiddenInstances;